import Vue from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import storeChildren from './store'

const routes = [
  {
    path: '/',
    component: () => import('../views/viewPage.vue'),
    children: storeChildren.children
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
